<template>
  <div class="search-select" v-click-outside="disableSelect">
    <div class="input-select">
      <!-- Multiple options -->
      <div v-if="multiple" class="multiple-select" @click="enableSelect">
        <span
          class="select-tag"
          v-if="multipleOpt.length > 0"
          v-for="(opt, index) in multipleOpt">
            <span v-if="label != null">{{ opt[label] }}</span>
            <span v-else>{{ opt }}</span>
            <div class="close-tag" @click.stop="removeOption(index)">x</div>
        </span>
        <input type="text" v-model="keyword" class="input-tag" @keyup.enter="enterOption(keyword)">
      </div>

      <!-- One options -->
      <input v-else type="text" v-model="keyword" @click="enableSelect" class="form-control">
      <i class="fa fa-angle-down icon" aria-hidden="true"></i>
    </div>
    <div v-if="showResultSearch" class="result-search">
      <div v-if="filteredOptions.length > 0">
        <ul>
          <li v-for="option in filteredOptions" @click="selectOption(option)">
            <span v-if="label != null">{{ option[label] }}</span>
            <span v-else>{{ option }}</span>
          </li>
        </ul>
      </div>
      <div v-else style="padding: 5px 15px;">
        No results
      </div>
    </div>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside'

export default {
  name: 'SelectComponent',
  data () {
    return {
      keyword: null,
      multipleOpt: [],
      optionSelected: null,
      filteredOptions: [],
      showResultSearch: false
    }
  },

  props: {
    value: {
      type: Array | String | Number | JSON | null
    },
    options: {
      type: Array
    },
    label: {
      type: String,
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    taggable: {
      type: Boolean,
      default: false
    }
  },

  directives: {
    clickOutside: vClickOutside.directive
  },

  watch: {
    keyword (val) {
      this.filterOptions(val)
    },

    value () {
      this.setValue()
    }
  },

  mounted () {
    this.setValue()
  },

  methods: {
    enableSelect () {
      if (this.keyword == null) this.keyword = ''
      this.showResultSearch = true
    },

    disableSelect () {
      this.showResultSearch = false
    },

    filterOptions (keyword) {
      if (keyword.length > 0) {
        this.filteredOptions = this.options.filter((option) => {
          return this.label != null
            ? option[this.label].toLowerCase().startsWith(keyword.toLowerCase())
            : option.toLowerCase().startsWith(keyword.toLowerCase())
        })

        if (this.filteredOptions.length === 0 && this.taggable === true) {
          this.filteredOptions = this.label != null
            ? [{ [this.label]: keyword }]
            : [keyword]
        }
      } else {
        this.filteredOptions = this.options
      }
    },

    selectOption (option) {
      if (this.multiple === true) {
        this.keyword = ''
        this.multipleOpt.push(option)
        this.$emit('input', this.multipleOpt)
      } else {
        this.keyword = this.label != null ? option[this.label] : option
        this.optionSelected = option
        this.$emit('input', this.optionSelected)
      }
      this.disableSelect()
    },

    removeOption (index) {
      if (this.multipleOpt.length > 0) {
        this.multipleOpt.splice(index, 1)
        this.$emit('input', this.multipleOpt)
      }
    },

    setValue () {
      if (this.value != null) {
        let typeData = typeof this.value

        // Array o JSON
        if (typeData === 'object') {
          if (Array.isArray(this.value)) {
            this.multipleOpt = this.value
          } else {
            this.keyword = this.value[this.label]
            this.optionSelected = this.value
          }
        }

        // String o Number
        if (typeData === 'string' || typeData === 'number') {
          this.keyword = this.value
          this.optionSelected = this.value
        }
      }
    },

    enterOption (keyword) {
      if (this.taggable === true) {
        this.selectOption(keyword)
      }
    }

  }
}
</script>

<style lang="scss" scoped>
.search-select {
  width: 100%;
  position: relative;

  .input-select {
    position: relative;

    .icon {
      position: absolute;
      right: 5px;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .multiple-select {
    padding: 5px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
    flex-basis: 100%;
    align-items: center;
    flex-grow: 1;
    position: relative;
    width: 100%;
    min-height: calc(2.25rem + 2px);
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;

    .select-tag {
      position: relative;
      display: flex;
      gap: 8px;
      background-color: #f0f0f0;
      border: 1px solid #ccc;
      border-radius: 4px;
      color: #333;
      margin: 4px 2px 0;
      padding: 0 0.25em;
      transition: opacity .25s;
      overflow: hidden;
      font-size: 17px;

      .close-tag {
        cursor: pointer;
        opacity: .6;
      }
    }

    .input-tag {
      padding-left: 5px;
      max-width: 100%;
      border: none;
      border-radius: 0.25rem;
      flex-grow: 1;
      min-width: 40px;
      width: 0;

      &:focus {
        outline: none;
      }
    }
  }

  .form-control.multiple {
    height: auto !important;
    cursor: text;
    min-height: calc(2.25rem + 2px) !important;
  }
  .result-search {
    width: 100%;
    color: #000;
    z-index: 1060;
    max-height: 300px;
    position: absolute;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 10px;
    background: #fff;
    border-radius: 0 0 8px 8px;
    border: 1px solid rgba(60,60,60,.26);

    ul {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        text-align: left;
        padding: 4px 15px;
        font-size: 15px;

        &:hover {
          cursor: pointer;
          background-color: #e8f0ff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/searchSelect/SearchSelect.vue